<template>
  <div
    class="manage-content page-card-wrapper page-card-wrapper-adapt-actual-width"
  >
    <div class="page-card-title">
      <span class="page-card-title-text">{{
        $t('text.manage_patient_data')
      }}</span>
    </div>
    <div class="pt-30 page-card-content">
      <div class="section-title mb-15">{{ $t('text.selected_patient') }}</div>
      <patientInput class="dark-font-patient-input" />
      <div v-if="p('Manage Module.Patients.Patient Data Privacy.Archive')">
        <el-divider></el-divider>
        <div class="section-title mb-15">{{ $t('text.archive_patient') }}</div>
        <div class="mb-5 general-font">
          {{ $t('text.archive_patient_warning') }}
        </div>
        <el-button
          type="success"
          plain
          class="common-btn mt-20"
          :loading="archiveLoading"
          :disabled="archiveLoading || !$store.state.patient.selectedPatient"
          @click="archivePatient()"
          >{{ $t('text.archive_patient_data') }}</el-button
        >
      </div>
      <!-- <div v-if="p('Manage Module.Patients.Patient Data Privacy.Restore')">
        <el-divider></el-divider>
        <div class="section-title mb-15">{{ $t('text.restore_patient') }}</div>
        <div class="mb-5 general-font">
          {{ $t('text.restore_patient_warning') }}
        </div>
        <div class="mb-5 general-font">
          {{ $t('text.archive_date') }}: 11/11/22
        </div>
        <el-button type="success" plain class="common-btn mt-20">{{
          $t('text.restore_patient_data')
        }}</el-button>
      </div> -->
      <div v-if="p('Manage Module.Patients.Patient Data Privacy.Export')">
        <el-divider></el-divider>
        <div class="section-title mb-15">
          {{ $t('text.export_patient').toUpperCase() }}
        </div>
        <div class="mb-5 general-font">
          {{ $t('text.export_patient_history_data') }}.
        </div>
        <el-button
          type="success"
          plain
          class="common-btn mt-20"
          :disabled="!$store.state.patient.selectedPatient"
          @click="showExportPatientData()"
          >{{ $t('text.export_patient_data') }}</el-button
        >
      </div>
      <div v-if="p('Manage Module.Patients.Patient Data Privacy.Delete')">
        <el-divider></el-divider>
        <div class="section-title mb-15">{{ $t('text.delete_account') }}</div>
        <div class="mb-5 general-font">
          {{ $t('text.data_management_desc') }}
        </div>
        <el-button
          type="success"
          plain
          class="common-btn mt-20"
          :loading="deleteLoading"
          :disabled="deleteLoading || !$store.state.patient.selectedPatient"
          @click="deletePatient()"
          >{{ $t('text.delete_account_data') }}</el-button
        >
      </div>
    </div>
    <ExportPatientData ref="exportPatientData" />
  </div>
</template>

<script>
import PatientInput from '@/components/patients/PatientInput.vue'
import ApiService from '@/services/ApiService.js'
import swal from 'sweetalert'
import ExportPatientData from '@/components/manage/patients/ExportPatientData.vue'
export default {
  data() {
    return {
      consentChecked: false,
      deleteLoading: false,
      archiveLoading: false
    }
  },
  components: {
    PatientInput,
    ExportPatientData
  },
  methods: {
    archivePatient() {
      if (!this.$store.state.patient.selectedPatient) return false
      let warningIconUrl = require('@/assets/image/warning-icon/warning.svg')
      this.$confirm(
        `<div class='warning-content'>${this.$t('text.you_about_to_archive')} ${
          this.$store.state.patient.selectedPatient.alias
        }</div>` + `<img class='warning-icon' src=${warningIconUrl}>`,
        this.$t('text.are_you_sure'),
        {
          confirmButtonText: this.$t('text.yes').toUpperCase(),
          cancelButtonText: this.$t('text.cancel').toUpperCase(),
          confirmButtonClass: 'confirm-btn',
          cancelButtonClass: 'cancel-btn',
          type: 'warning',
          customClass: 'delete-warning-box',
          showClose: true,
          closeOnClickModal: false,
          dangerouslyUseHTMLString: true
        }
      ).then(() => {
        this.handleArchive()
      })
    },
    handleArchive() {
      this.archiveLoading = true
      ApiService.ArchivePatient(
        this.$store.state.patient.selectedPatient.patientId
      )
        .then(response => {
          this.archiveLoading = false
          if (response.data.success) {
            this.$bus.$emit('updatePatientDropdown')
            swal({
              icon: 'success',
              timer: 2000,
              title: this.$t('text.archived_successfully')
            })
          } else {
            swal({
              icon: 'error',
              timer: 2000,
              title: this.$t('text.failed'),
              text: response.data.msg
            })
          }
        })
        .catch(() => {
          this.archiveLoading = false
          swal({
            icon: 'error',
            timer: 2000,
            title: 'Archived failed'
          })
        })
    },
    deletePatient() {
      if (!this.$store.state.patient.selectedPatient) return false
      let warningIconUrl = require('@/assets/image/warning-icon/warning.svg')
      this.$confirm(
        `<div class='warning-content'>${this.$t(
          'text.delete_patient_warning'
        )}</div><img class='warning-icon' src=${warningIconUrl}>`,
        this.$t('text.you_able_to_delete_data') +
          ' ' +
          this.$store.state.patient.selectedPatient.alias,
        {
          confirmButtonText: this.$t('text.delete').toUpperCase(),
          cancelButtonText: this.$t('text.cancel').toUpperCase(),
          confirmButtonClass: 'confirm-btn',
          cancelButtonClass: 'cancel-btn',
          type: 'warning',
          customClass: 'delete-warning-box',
          showClose: true,
          closeOnClickModal: false,
          dangerouslyUseHTMLString: true
        }
      )
        .then(() => {
          this.handleDeletePatient()
        })
        .catch(() => {})
    },
    handleDeletePatient() {
      this.deleteLoading = true
      ApiService.DeletePatient(
        this.$store.state.patient.selectedPatient.patientId
      )
        .then(response => {
          this.deleteLoading = false
          if (response.data.success) {
            this.$bus.$emit('updatePatientDropdown')
            swal({
              icon: 'success',
              timer: 2000,
              title: this.$t('text.deleted_successfully')
            })
          } else {
            swal({
              icon: 'error',
              timer: 2000,
              title: this.$t('text.deleted_failed'),
              text: response.data.msg
            })
          }
        })
        .catch(() => {
          this.deleteLoading = false
          swal({
            icon: 'error',
            timer: 2000,
            title: this.$t('text.deleted_failed')
          })
        })
    },
    showExportPatientData() {
      this.$refs.exportPatientData.openDialog()
    }
  }
}
</script>
